import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Dropdown,
  Form,
  Icon,
  Input,
  Menu,
  Row,
  Select,
} from '@oscar/theme';
import { useDeepCompareEffect } from '@oscar/utils';
import { TYPE_OF_REQUEST } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';
import apiClient from '@oscar/request';

const { useForm } = Form;

interface TypeOfRequest {
  text: string;
  value: number;
}

const { Option } = Select;

const menuBtnExport = (handleExport: any) => {
  return (
    <Menu>
      <Menu.Item
        key="export-pdf"
        icon={<Icon icon="file-layout-pdf" size={22} />}
        onClick={() => handleExport(true)}
      >
        Export PDF
      </Menu.Item>
      <Menu.Item
        key="export-xls"
        icon={<Icon icon="file-layout-xls" size={22} />}
        onClick={() => handleExport(false)}
      >
        Export XLS
      </Menu.Item>
    </Menu>
  );
};

const defaultTorOptions: TypeOfRequest[] = [];

function FilterTable(props: any) {
  const { actionTable, metadata } = props;
  const [listTor, setListTor] = React.useState(defaultTorOptions);
  const [isVisible, setisVisible] = React.useState<boolean>(false);
  const [form] = useForm();

  useDeepCompareEffect(() => {
    form.setFieldsValue(metadata?.filters);
  }, [metadata]);

  useEffect(() => {
    const listTypeOfRequest: TypeOfRequest[] = [];
    for (const [key, value] of Object.entries(TYPE_OF_REQUEST)) {
      listTypeOfRequest.push({
        text: value.TEXT,
        value: value.VALUE,
      });
    }
    setListTor(listTypeOfRequest);
  }, []);

  const handleSearchEnter = debounce((value: any) => {
    actionTable?.methods?.fetchData({
      filters: { keyWord: value },
    });
  }, 500);

  const handleChangeTypeOfRequest = (value: any) => {
    if (value) {
      actionTable?.methods?.fetchData({
        filters: { typeOfWork: value },
      });
    } else {
      actionTable?.methods?.fetchData({ filters: { typeOfWork: 0 } });
    }
  };

  const customRequest = (isExportPdf: boolean) => {
    return apiClient
      .request({
        method: 'POST',
        url: APIS.EXPORT_DATA_REQUEST,
        responseType: 'blob',
        data: {
          filter: {
            keyWord: metadata?.filters?.keyWord || '',
            typeOfWork: metadata?.filters?.typeOfWork || 0,
            startDate: metadata?.filters?.dateRange?.[0] || null,
            endDate: metadata?.filters?.dateRange?.[1] || null,
            listStatus: metadata?.filters?.status || '',
            listArea: metadata?.filters?.areaSection?.[0] || '',
            listSection: metadata?.filters?.areaSection?.[1] || '',
            isHomeTab: true,
          },
          sortField: '',
          sortOrder: '',
          pagination: { ...metadata?.pagination },
          isExportPdf: isExportPdf,
        },
        ...{ isDownload: true },
      })
      .then(res => {
        return;
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  };

  return (
    <>
      <Form layout="vertical" form={form}>
        <div className="group-fillter-request">
          <Row key="filter-request" gutter={16}>
            {/* Search for ID/Description/Requestor */}
            <Col xl={13} xxl={14}>
              <Form.Item
                name="keyWord"
                label="Search for ID/Description/Requestor"
                className="title-filter-request"
                getValueFromEvent={(e: any) => {
                  handleSearchEnter(e.target.value);
                  return e.target.value;
                }}
              >
                <Input
                  size="large"
                  placeholder="Search"
                  prefix={<SearchOutlined />}
                />
              </Form.Item>
            </Col>

            {/* Type of Request */}
            <Col span={8}>
              <Form.Item
                name="typeOfWork"
                label="Type of Request"
                className="title-filter-request"
                getValueFromEvent={value => {
                  handleChangeTypeOfRequest(value);
                  return value;
                }}
              >
                <Select size="large">
                  {listTor.map((tor, key) => (
                    <Option value={tor.value} key={`${key}${tor.value}`}>
                      {tor.text}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/* Button Export */}
            <Col xl={3} xxl={2} className="padding-btn-export">
              <Dropdown
                overlay={menuBtnExport(customRequest)}
                placement="bottomRight"
                trigger={['click']}
              >
                <Button type="primary" ghost size="large">
                  Export <DownloadOutlined />
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </div>
      </Form>
    </>
  );
}

export default FilterTable;
